<template>
  <div>
    <v-file-input
      :disabled="loading || isLoaded"
      show-size
      prepend-icon=""
      color="primary"
      :label="label"
      filled
      :accept="accept"
      v-model="editableFileName"
      hide-details
    >


    </v-file-input>
    <div v-if="loading">

      <v-progress-linear
        :model-value="progressUpload"
        :value="progressUpload"
        color="primary"
        height="5"
      ></v-progress-linear>
      <small>Uploading file to server {{ Math.round(progressUpload) }}%...</small>
    </div>
  </div>
</template>
<script>
  import { BlockBlobClient } from "@azure/storage-blob"
  import { mapActions } from "vuex"

  export default {
    name: "UploadToBlobStorage",
    props: {
      label: { required: false, default: null },
      accept: { required: false, default: null },
      file: { required: true, default: null }
    },
    data: () => ({
      loading: false,
      progressUpload: 0,
      isLoaded: false
    }),
    computed: {
      editableFileName: {
        get () {
          return this.file ? [this.file] : null
        },
        set (value) {
          this.$emit("setBlobFileName", value)
        }
      }
    },
    methods: {
      ...mapActions("project", {
        fetchUploadUrl: "fetchUploadUrl"
      }),
      async uploadToBlob () {
        this.loading = true
        this.isLoaded = false
        if (this.file?.name) {
          const uploadUrl = await this.fetchUploadUrl(this.file.name)
          const blockBlobClient = new BlockBlobClient(uploadUrl)
          await blockBlobClient.uploadData(this.file, {
            onProgress: (ev) => {
              this.progressUpload = (ev.loadedBytes / this.file.size) * 100
            }
          })
          this.isLoaded = true
        }
        this.loading = false
      }
    },
    mounted () {
      this.$emit("setBlobFileName", null)
    }
  }
</script>
<style scoped>

</style>
